import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app'

import { UserProfile } from './UserProfile'

export const profileRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/profile',
    component: UserProfile,
})
